<template>
  <div
    v-click-outside="onClose"
    class="aside-container">
    <div class="aside-brand">
      <img src="@/assets/logo.png" class="logo" />
    </div>
    <div class="aside-menu-container">
      <div class="menu-group-container">
        <div class="menu-header">เนื้อหา</div>
        <router-link
          class="menu-item"
          :to="'/videos'">
          <i class="fas fa-play icon"></i>
          <div class="title">วิดีโอ</div>
        </router-link>
        <router-link
          class="menu-item menu-item-live"
          :to="'/live'">
          <span class="badge badge-live">LIVE</span>
          <div class="title">วิดีโอถ่ายทอดสด</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/episodes'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">ตอน</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/programs'">
          <i class="fas fa-tv icon"></i>
          <div class="title">รายการ</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/galleries'">
          <i class="fas fa-images icon"></i>
          <div class="title">แกลเลอรีภาพ</div>
        </router-link>
        <a class="menu-item" href="//cms.altv.tv/default/Home" target="_blank">
          <i class="fa fa-newspaper-o icon" />
          <div class="title">ข่าว</div>
        </a>
      </div>
      <div class="menu-group-container">
        <div class="menu-header">ผัง</div>
        <router-link
          class="menu-item"
          :to="'/schedules'">
          <i class="fas fa-calendar-day icon"></i>
          <div class="title">ผังวัน</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/schedule-templates'">
          <i class="fas fa-calendar-day icon"></i>
          <div class="title">เทมเพลตผัง</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/schedules-monthly'">
          <i class="far fa-calendar-alt icon"></i>
          <div class="title">ผังเดือน</div>
        </router-link>
      </div>
      <div class="menu-group-container">
        <div class="menu-header">จัดชุด</div>
        <router-link exact class="menu-item" :to="'/collections?type=video'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">เพลย์ลิสต์</div>
        </router-link>
        <router-link exact class="menu-item" :to="'/collections?type=playlist'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">ชุดเพลย์ลิสต์</div>
        </router-link>
        <router-link exact class="menu-item" :to="'/collections?type=episode'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">ชุดตอน</div>
        </router-link>
        <router-link exact class="menu-item" :to="'/collections?type=program'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">ชุดรายการ</div>
        </router-link>
      </div>
      <div class="menu-group-container" v-if="designerMenuList && designerMenuList.length > 0">
        <div class="menu-header">ตกแต่ง</div>
        <router-link exact class="menu-item" :to="'/pages-designer'">
          <i class="fas fa-image icon"></i>
          <div class="title">ลิสต์หน้าตกแต่ง</div>
        </router-link>
        <router-link exact class="menu-item" :to="'/popup'">
          <i class="fa fa-external-link icon"></i>
          <div class="title">ป๊อปอัพ</div>
        </router-link>
<!--         <div v-for="(menu, index) in designerMenuList" :key="index" >
          <router-link
            class="menu-item"
            :to="{ name: 'pageDesignerDetail', params: {pageDesignerKey: menu._id}}">
            <i class="fas fa-image icon"></i>
            <div class="title">{{menu.title}}</div>
          </router-link>
        </div> -->
      </div>
      <div class="menu-group-container">
        <div class="menu-header">จัดการระบบ</div>
        <router-link
          class="menu-item"
          :to="'/landingpage'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">จัดการแลนดิ้งเพจ</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/taxonomy'">
          <i class="fas fa-layer-group icon"></i>
          <div class="title">หมวดหมู่</div>
        </router-link>
        <router-link
          v-if="getUserRole() === 'admin'"
          class="menu-item"
          :to="'/accounts'">
          <i class="fas fa-users-cog icon"></i>
          <div class="title">ส่วนจัดการสมาชิก</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/custom-links'">
          <i class="fas fa-link icon"></i>
          <div class="title">ลิงก์สั้น</div>
        </router-link>
        <router-link
          class="menu-item"
          :to="'/comments'">
          <i class="fas fa-comment-dots icon"></i>
          <div class="title">ความคิดเห็น</div>
        </router-link>
        <!-- <router-link
          v-if="getUserRole() === 'admin'"
          class="menu-item"
          :to="'/settings'">
          <i class="fas fa-cogs icon"></i>
          <div class="title">ตั้งค่า</div>
        </router-link> -->
      </div>
    </div>
    <div class="aside-user" v-if="currentUser">
      <div class="user-container" @click="onToggleUserMenu">
        <Logo :user="currentUser" />
        <div class="user-information">
          <div class="username">
            {{currentUser.name}}
          </div>
        </div>
        <div class="role">
          <span class="badge badge-status success">
            {{currentUser.roleId}}
          </span>
        </div>
        <i class="fa fa-chevron-down chevron-icon ml-2" :class="{ toggle: userMenu }" />
      </div>
      <div class="menu-container" v-if="userMenu">
        <router-link class="menu-item" :to="{ name: 'profileEdit', params: { accountId: currentUser.id}}">
          <i class="fa fa-user mr-2"></i>
          <div class="title">แก้ไขข้อมูลผู้ใช้</div>
        </router-link>
        <div class="menu-item" @click="onClickSignOut">
          <i class="fa fa-sign-out mr-2"></i>
          <div class="title">ออกจากระบบ</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ClickOutside from 'vue-click-outside';
import { mapGetters } from 'vuex';
import { logout } from '@/auth/api';
import { loadDesignerMenuList } from '@/pageDesigner/api';
import Logo from '@/components/Logo.vue';

export default {
  directives: {
    ClickOutside,
  },
  data() {
    return {
      designerMenuList: [],
      userMenu: false,
    };
  },
  components: {
    Logo,
  },
  created() {
    this.loadDesignerMenuList();
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  methods: {
    async loadDesignerMenuList() {
      const response = await loadDesignerMenuList();
      this.designerMenuList = response.data.data;
    },
    async onClickSignOut() {
      try {
        await logout();
        this.$store.dispatch('destoryCurrentUser');
      } catch (error) {
        // Do something
      }
    },
    onToggleUserMenu() {
      this.userMenu = !this.userMenu;
    },
    onClose() {
      this.$emit('closeSidebar');
    },
    getUserRole() {
      return _.get(this.currentUser, 'roleId', '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/aside.scss';


.menu-item-live {
  position: relative;

  .badge-live {
    padding-top: $spacer * 0.25;
    padding-bottom: $spacer * 0.25;
    font-size: $font-size-base * 0.5;
    width: 26px;
    margin-right: $spacer * 0.4;
    background-color: #495057;
    color: white;
  }
}
</style>
